/**
 * Constructs a full URL for a file/resource
 * If the URL is already absolute (starts with http:// or https://), return as-is
 * Otherwise, prepend the API base URL
 *
 * @param {string} url - The URL to process (can be relative or absolute)
 * @returns {string} - The full URL
 */
export function getFileUrl(url) {
  if (!url) {
    return '';
  }

  // If URL is already absolute, return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  // Otherwise, prepend the API base URL
  return process.env.VUE_APP_API_BASE_URL + url;
}
